<template>
  <div style="width: 100%">
    <v-row v-if="mensagem">
      <v-col>
        <app-alert
          :message="mensagem"
          icon="info"
          type="info"
        />
      </v-col>
    </v-row>
    <v-row v-if="dispensas.length > 0">
      <v-col>
        <app-title texto="MOTIVOS DE DISPENSA DO DIAGNÓSTICO" />
        <v-data-table :headers="headers" :items="dispensas" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AppAlert from '@/components/core/AppAlert';
import AppTitle from '@/components/core/AppTitle';

export default {
  name: 'InfoDispensa',

  components: { AppAlert, AppTitle },

  props: {
    mensagem: {
      type: String,
      required: false,
      default: null,
    },
    dispensas: {
      type: Array,
      required: false,
      default: () => [],
    },
  },

  data() {
    return {
      headers: [
        { text: 'DISPENSADO', value: 'usuario.nome', sortable: false },
        { text: 'MOTIVO DE DISPENSA', value: 'motivo.descricao', sortable: false },
      ],
    };
  },
};
</script>
